// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as jsxRuntime from "react/jsx-runtime";
import { InstallAppButton } from "../features/pwa/InstallAppButton.jsx";
import { IconShieldCheck } from "../components/icons.jsx";
import { IconStar } from "../components/icons.jsx";
import { IconFlame } from "../components/icons.jsx";
import { IconCircleX } from "../components/icons.jsx";
import { IconBolt } from "../components/icons.jsx";
import { IconCrown } from "../components/icons.jsx";
import { IconSword } from "../components/icons.jsx";
import { Qy } from "../assets.jsx";
import { Zy } from "../assets.jsx";
import { Vy } from "../assets.jsx";
import { $y } from "../assets.jsx";
import { Ky } from "../assets.jsx";
import { Jy } from "../assets.jsx";
import { Wy } from "../assets.jsx";
import { Iy } from "../assets.jsx";
import { Fy } from "../assets.jsx";
import { Py } from "../assets.jsx";
import { e_ } from "../assets.jsx";
import * as React from "react";
import { StatisticsPage } from "./StatisticsPage.jsx";
import { OpeningHistoryPage } from "./OpeningHistoryPage.jsx";
import { PromocodePage } from "./PromocodePage.jsx";
import { PlayerAvatar } from "../components/PlayerAvatar.jsx";
import { IconUsers } from "../components/icons.jsx";
import { BadgeTooltip } from "../components/BadgeTooltip.jsx";
import { PlayerDescription } from "../components/PlayerDescription.jsx";
import { IconChevronDown } from "../components/icons.jsx";
import { IconBox } from "../components/icons.jsx";
import { IconCreditCard } from "../components/icons.jsx";
import { IconTrophy } from "../components/icons.jsx";
import { IconUsersGroup } from "../components/icons.jsx";
import { IconArrowRight } from "../components/icons.jsx";
import { IconLink } from "../components/icons.jsx";
import { IconMedal } from "../components/icons.jsx";
import { IconChevronRight } from "../components/icons.jsx";
import { IconClock } from "../components/icons.jsx";
import { IconChartBar } from "../components/icons.jsx";
import { IconTicket } from "../components/icons.jsx";
export const t_ = u => ({
  admin: {
    className: "admin",
    icon: jsxRuntime.jsx(IconShieldCheck, {})
  },
  VIP: {
    className: "vip",
    icon: jsxRuntime.jsx(IconStar, {})
  },
  MVP: {
    className: "mvp",
    icon: jsxRuntime.jsx(IconFlame, {})
  },
  X: {
    className: "x",
    icon: jsxRuntime.jsx(IconCircleX, {})
  },
  OP: {
    className: "op",
    icon: jsxRuntime.jsx(IconBolt, {})
  },
  GOD: {
    className: "god",
    icon: jsxRuntime.jsx(IconCrown, {})
  },
  LEGEND: {
    className: "legend",
    icon: jsxRuntime.jsx(IconSword, {})
  }
})[u];
export const a_ = u => u ? {
  1: {
    image: Qy,
    title: "1 год с MetaCard",
    description: "Бейдж за год в MetaCard."
  },
  2: {
    image: Zy,
    title: "2 года с MetaCard",
    description: "Бейдж за два года в MetaCard."
  },
  3: {
    image: Vy,
    title: "3 года с MetaCard",
    description: "Бейдж за три года в MetaCard."
  }
}[u] : void 0;
export const fm = (u = 0) => [{
  threshold: 100,
  image: $y,
  title: "100 открытых карт"
}, {
  threshold: 1e3,
  image: Ky,
  title: "1 000 открытых карт"
}, {
  threshold: 1e4,
  image: Jy,
  title: "10 000 открытых карт"
}, {
  threshold: 25e3,
  image: Wy,
  title: "25 000 открытых карт"
}, {
  threshold: 5e4,
  image: Iy,
  title: "50 000 открытых карт"
}, {
  threshold: 1e5,
  image: Fy,
  title: "100 000 открытых карт"
}, {
  threshold: 5e5,
  image: Py,
  title: "500 000 открытых карт"
}, {
  threshold: 1e6,
  image: e_,
  title: "1 000 000 открытых карт"
}].filter(o => u >= o.threshold).map(o => ({
  ...o,
  description: `Бейдж за открытие ${o.title.toLowerCase()}.`
}));
export const l_ = u => {
  const o = u % 100,
    m = o >= 11 && o <= 14 ? "карт" : u % 10 === 1 ? "карта" : u % 10 >= 2 && u % 10 <= 4 ? "карты" : "карт";
  return `${u % 10 === 1 && o !== 11 ? "Осталась" : "Осталось"} ${u.toLocaleString("ru-RU")} ${m}`;
};
export const n_ = u => {
  const o = u.trim().split(/\s+/).filter(Boolean).length;
  return o <= 1 ? u.length <= 11 ? "short" : u.length <= 18 ? "medium" : "compact" : o === 2 && u.length <= 18 ? "medium" : u.length > 38 ? "tiny" : "compact";
};
export const Zi = u => u.length <= 8 ? "large" : u.length <= 10 ? "medium" : u.length <= 13 ? "compact" : "tiny";
export function ProfilePage({
  player: u,
  meta: o,
  onOpenCollection: m,
  onCopyReferral: r,
  onShareReferral: g,
  onNotice: j,
  onPromoRedeemed: B
}) {
  const [U, N] = React.useState(!1),
    y = [u.firstName, u.lastName].filter(Boolean).join(" "),
    X = React.useRef(null),
    M = React.useCallback(() => N(!1), []),
    [R, H] = React.useState(!1),
    [Y, P] = React.useState(!1),
    [W, ee] = React.useState(!1),
    [ie, w] = React.useState(!1),
    I = React.useCallback(() => P(!1), []),
    ne = React.useCallback(() => ee(!1), []),
    oe = React.useCallback(() => w(!1), []),
    [T, D] = React.useState("season"),
    le = t_(o.privilege),
    te = a_(o.registrationBadge),
    Z = [...(te ? [te] : []), ...fm(o.openedTotal)].slice(0, 4),
    V = (ce = 0) => ce.toLocaleString("ru-RU"),
    ae = o.referral || {
      link: `https://t.me/Meta_CardBot?start=${u.id}`,
      total: 0,
      active: 0,
      earnedSpins: 0
    },
    Te = o.collectionTotal ?? 0,
    je = o.collectionOwned ?? 0,
    k = Math.max(0, Te - je),
    O = o.totalPoints !== void 0 && o.totalPoints !== o.universePoints || o.totalPointsAllTime !== void 0 && o.totalPointsAllTime !== o.universePointsAllTime,
    L = T === "all" ? o.universePointsAllTime ?? o.universePoints : o.universePoints,
    se = T === "all" ? o.totalPointsAllTime ?? o.totalPoints : o.totalPoints,
    C = T === "all" ? o.openedTotal : o.openedSeason,
    f = T === "all" ? "За всё время" : "Этот сезон",
    h = T === "all" ? "За всё время" : "Этот месяц",
    p = o.universe || "Мультиверс",
    G = n_(p),
    F = (o.registrationBadge ? 1 : 0) + fm(o.openedTotal).length;
  return Y ? jsxRuntime.jsx(StatisticsPage, {
    meta: o,
    onBack: I
  }) : W ? jsxRuntime.jsx(OpeningHistoryPage, {
    onBack: ne
  }) : ie ? jsxRuntime.jsx(PromocodePage, {
    onBack: oe,
    onRedeemed: B
  }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsx("section", {
      className: "mc-profile-card",
      children: jsxRuntime.jsxs("div", {
        className: "mc-profile-top",
        children: [jsxRuntime.jsx("div", {
          className: "mc-profile-avatar",
          style: o.eventFrame ? {border: `3px solid ${o.eventFrame.color}`, boxShadow: `0 0 18px ${o.eventFrame.color}55`} : undefined,
          title: o.eventFrame?.name,
          children: jsxRuntime.jsx(PlayerAvatar, {
            player: u,
            className: "profile-photo"
          })
        }), jsxRuntime.jsxs("div", {
          className: "mc-profile-identity",
          children: [jsxRuntime.jsxs("h1", {
            children: [jsxRuntime.jsx("span", {
              className: "mc-profile-name",
              children: y
            }), le && jsxRuntime.jsx("span", {
              className: `mc-privilege-badge ${le.className}`,
              children: le.icon
            })]
          }), o.title && jsxRuntime.jsx("p", {
            className: "mc-profile-title",
            title: o.title,
            children: o.title
          }), jsxRuntime.jsxs("div", {
            className: "mc-profile-meta-row",
            children: [jsxRuntime.jsx("div", {
              className: "mc-profile-mini-stats",
              children: jsxRuntime.jsxs("div", {
                className: "friends-stat",
                children: [jsxRuntime.jsxs("b", {
                  children: [jsxRuntime.jsx(IconUsers, {}), o.friends]
                }), jsxRuntime.jsx("small", {
                  children: "Друзья"
                })]
              })
            }), Z.length > 0 && jsxRuntime.jsx("section", {
              className: "mc-profile-badges",
              children: jsxRuntime.jsx("div", {
                children: Z.map((ce, ue) => jsxRuntime.jsx("button", {
                  type: "button",
                  className: "mc-profile-badge",
                  "aria-label": ce.title,
                  "aria-expanded": U === ue,
                  "aria-describedby": U === ue ? "mc-profile-badge-details" : void 0,
                  onClick: Me => {
                    X.current = Me.currentTarget, N(U === ue ? !1 : ue);
                  },
                  children: jsxRuntime.jsx("img", {
                    src: ce.image,
                    alt: ce.title
                  })
                }, ce.title))
              })
            })]
          })]
        })]
      })
    }), U !== !1 && Z[U] && X.current && jsxRuntime.jsx(BadgeTooltip, {
      anchor: X.current,
      title: Z[U].title,
      description: Z[U].description,
      onClose: M
    }, Z[U].title), jsxRuntime.jsx(PlayerDescription, {
      description: o.description
    }), jsxRuntime.jsxs("section", {
      className: "mc-game-stats",
      "aria-labelledby": "mc-stats-heading",
      children: [jsxRuntime.jsxs("div", {
        className: "mc-game-stats-heading",
        children: [jsxRuntime.jsx("h2", {
          id: "mc-stats-heading",
          children: "Статистика игрока"
        }), jsxRuntime.jsxs("label", {
          className: "mc-stats-period",
          children: [jsxRuntime.jsxs("select", {
            "aria-label": "Период статистики",
            value: T,
            onChange: ce => D(ce.target.value),
            children: [jsxRuntime.jsx("option", {
              value: "season",
              children: "Этот сезон"
            }), jsxRuntime.jsx("option", {
              value: "all",
              children: "За всё время"
            })]
          }), jsxRuntime.jsx(IconChevronDown, {
            "aria-hidden": "true"
          })]
        })]
      }), jsxRuntime.jsxs("div", {
        className: "mc-stat-grid",
        children: [jsxRuntime.jsx("article", {
          className: "mc-collection-stat",
          children: jsxRuntime.jsxs("button", {
            type: "button",
            onClick: m,
            children: [jsxRuntime.jsxs("span", {
              children: [jsxRuntime.jsx(IconBox, {}), "Коллекция"]
            }), jsxRuntime.jsxs("b", {
              className: `mc-stat-value ${Zi(`${V(je)} / ${V(Te)}`)}`,
              children: [V(je), jsxRuntime.jsxs("i", {
                children: [" / ", V(Te)]
              })]
            }), Te > 0 && jsxRuntime.jsx("small", {
              children: k === 0 ? "Коллекция собрана" : l_(k)
            })]
          })
        }), jsxRuntime.jsxs("article", {
          children: [jsxRuntime.jsxs("span", {
            children: [jsxRuntime.jsx(IconCreditCard, {}), "Открыто карт"]
          }), jsxRuntime.jsx("b", {
            className: `mc-stat-value ${Zi(V(C ?? 0))}`,
            children: V(C)
          }), jsxRuntime.jsx("small", {
            children: f
          })]
        }), jsxRuntime.jsxs("article", {
          children: [jsxRuntime.jsxs("span", {
            children: [jsxRuntime.jsx(IconTrophy, {}), "PTS вселенной"]
          }), jsxRuntime.jsx("b", {
            className: `mc-stat-value ${Zi(V(L ?? 0))}`,
            children: V(L)
          }), jsxRuntime.jsx("small", {
            children: h
          })]
        }), O ? jsxRuntime.jsxs("article", {
          children: [jsxRuntime.jsxs("span", {
            children: [jsxRuntime.jsx(IconTrophy, {}), "PTS общий"]
          }), jsxRuntime.jsx("b", {
            className: `mc-stat-value ${Zi(V(se ?? 0))}`,
            children: V(se)
          }), jsxRuntime.jsx("small", {
            children: h
          })]
        }) : jsxRuntime.jsxs("article", {
          className: "mc-universe-stat",
          children: [jsxRuntime.jsxs("span", {
            children: [jsxRuntime.jsx(IconBox, {}), "Вселенная"]
          }), jsxRuntime.jsx("b", {
            className: `mc-universe-name ${G}`,
            title: p,
            children: p
          }), jsxRuntime.jsx("small", {
            children: "Выбрана сейчас"
          })]
        })]
      })]
    }), jsxRuntime.jsxs("section", {
      className: "mc-referral-card",
      children: [jsxRuntime.jsxs("div", {
        className: "mc-referral-heading",
        children: [jsxRuntime.jsx("span", {
          children: jsxRuntime.jsx(IconUsersGroup, {})
        }), jsxRuntime.jsxs("div", {
          children: [jsxRuntime.jsx("h2", {
            children: "Пригласи друга"
          }), jsxRuntime.jsxs("p", {
            children: ["Друг откроет 10 карт — тебе ", jsxRuntime.jsx("b", {
              children: "+3 крутки"
            })]
          })]
        }), jsxRuntime.jsx("button", {
          type: "button",
          className: "mc-referral-expand",
          "aria-label": R ? "Скрыть подробности рефералов" : "Показать подробности рефералов",
          "aria-expanded": R,
          onClick: () => H(ce => !ce),
          children: R ? "−" : "+"
        })]
      }), jsxRuntime.jsxs("button", {
        type: "button",
        className: "mc-referral-primary",
        onClick: () => g(ae.link),
        children: ["Пригласить ", jsxRuntime.jsx(IconArrowRight, {})]
      }), R && jsxRuntime.jsxs("div", {
        className: "mc-referral-details",
        children: [jsxRuntime.jsxs("div", {
          className: "mc-referral-stats",
          children: [jsxRuntime.jsxs("div", {
            children: [jsxRuntime.jsx("b", {
              children: ae.total
            }), jsxRuntime.jsx("span", {
              children: "Приглашено"
            })]
          }), jsxRuntime.jsxs("div", {
            children: [jsxRuntime.jsx("b", {
              children: ae.active
            }), jsxRuntime.jsx("span", {
              children: "Активных"
            })]
          }), jsxRuntime.jsxs("div", {
            children: [jsxRuntime.jsx("b", {
              children: ae.earnedSpins
            }), jsxRuntime.jsx("span", {
              children: "Круток получено"
            })]
          })]
        }), jsxRuntime.jsxs("button", {
          type: "button",
          className: "mc-referral-copy",
          onClick: () => {
            r(ae.link);
          },
          children: [jsxRuntime.jsx(IconLink, {}), "Скопировать ссылку"]
        })]
      })]
    }), jsxRuntime.jsxs("nav", {
      className: "mc-profile-sections",
      "aria-label": "Разделы профиля",
      children: [jsxRuntime.jsxs("button", {
        type: "button",
        className: "mc-profile-section-row",
        onClick: () => j("Достижения пока недоступны"),
        children: [jsxRuntime.jsx(IconMedal, {
          "aria-hidden": "true"
        }), jsxRuntime.jsx("span", {
          children: "Достижения"
        }), jsxRuntime.jsxs("small", {
          children: [F, "/11"]
        }), jsxRuntime.jsx(IconChevronRight, {
          "aria-hidden": "true"
        })]
      }), jsxRuntime.jsxs("button", {
        type: "button",
        className: "mc-profile-section-row",
        onClick: () => ee(!0),
        children: [jsxRuntime.jsx(IconClock, {
          "aria-hidden": "true"
        }), jsxRuntime.jsx("span", {
          children: "История открытий"
        }), jsxRuntime.jsx(IconChevronRight, {
          "aria-hidden": "true"
        })]
      }), jsxRuntime.jsxs("button", {
        type: "button",
        className: "mc-profile-section-row",
        onClick: () => P(!0),
        children: [jsxRuntime.jsx(IconChartBar, {
          "aria-hidden": "true"
        }), jsxRuntime.jsx("span", {
          children: "Статистика"
        }), jsxRuntime.jsx(IconChevronRight, {
          "aria-hidden": "true"
        })]
      }), jsxRuntime.jsxs("button", {
        type: "button",
        className: "mc-profile-section-row",
        onClick: () => w(!0),
        children: [jsxRuntime.jsx(IconTicket, {
          "aria-hidden": "true"
        }), jsxRuntime.jsx("span", {
          children: "Промокод"
        }), jsxRuntime.jsx(IconChevronRight, {
          "aria-hidden": "true"
        })]
      })]
    }), jsxRuntime.jsx(InstallAppButton, { variant: "profile" })]
  });
}
